import React from "react";
import { useLocation } from "react-router-dom";
import LeadsTable from "./LeadsTable";
import GoBackButton from "../../Component/Common/GoBackButton";

export default function LeadsViewPage() {
  const { state } = useLocation();

  const allLeads = state?.leads || [];
  const applyFilter = state?.applyFilter || "All";

  const [filterStatus, setFilterStatus] = React.useState(applyFilter);

  const filteredLeads = React.useMemo(() => {
    if (filterStatus === "All") return allLeads;
    return allLeads.filter((l) => l.status === filterStatus);
  }, [allLeads, filterStatus]);

  return (
    <div className="min-h-screen bg-slate-100 flex flex-col">
      <header className="bg-white border-b border-slate-200">
        <div className="mx-auto px-4 py-3 flex items-center justify-between gap-3">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 rounded-xl bg-blue-600 flex items-center justify-center text-white font-bold">
              EX
            </div>
            <div>
              <div className="text-sm md:text-base font-semibold text-slate-900">
                Leads ({filterStatus})
              </div>
            </div>
          </div>
        </div>
      </header>

      <LeadsTable
        leads={filteredLeads}
        filterStatus={filterStatus}
        setFilterStatus={setFilterStatus}
      />
    </div>
  );
}
